<div class="app-list-container">
  <ul class="app-list">
    <ng-content></ng-content>
  </ul>
</div>
